import { render, staticRenderFns } from "./GithubPublishModal.vue?vue&type=template&id=3c4d0270&"
import script from "./GithubPublishModal.vue?vue&type=script&lang=js&"
export * from "./GithubPublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubPublishModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GithubPublishModal.vue
// module id = 2369
// module chunks = 1